module.exports = __webpack_public_path__ + "img/Download.4f2f72d7.svg";